export class Clock {
    seconds = 0;
    minutes = 0;
    interval = null;
    status = 0;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/clock.model.ts